import React, { FC, useState } from 'react'
import { Range as RangeComponent } from '../range/Range'
import { Range } from '../../types/plann3r'
import { IProps } from './types'
import { convertHourToUTC } from '../../utils/general'

const Ranges: FC<IProps> = ({ ranges, save }) => {
  const [ranges_state, setranges_state] = useState(ranges)

  const removeRange = (id: number) => {
    setranges_state(ranges_state.filter((range, index) => index !== id))
    onSave()
  }
  const addRange = () => {    
    setranges_state([...ranges_state, {
      days: [0, 1, 2, 3, 4],
      from: convertHourToUTC(9),
      to: convertHourToUTC(17),
    }])
    onSave()
  }
  const updateFrom = (id: number, from: number) => {
    setranges_state(ranges_state.map((range, index) => {
      if (index === id) {
        // Store everything in state as UTC, the component takes care of displaying local time
        range.from = convertHourToUTC(from)
      }
      return range
    }))
  }
  const updateTo = (id: number, to: number) => {
    setranges_state(ranges_state.map((range, index) => {
      if (index === id) {
        // Store everything in state as UTC, the component takes care of displaying local time
        range.to = convertHourToUTC(to)
      }
      return range
    }))
  }
  const toggleDay = (id: number, day: number) => {
    setranges_state(ranges_state.map((range, index) => {
      if (index === id) {
        const index = range.days.indexOf(day)

        if (index === -1) {
          range.days.push(day)
        } else {
          range.days.splice(index, 1)
        }
      }
      return range
    }))
  }

  const onSave = () => {
    save(ranges_state)
  }

  return (
    <div className="ranges">
      {ranges_state.map((range: Range, index: number) => {
        return (
          <RangeComponent
            key={ index }
            range={range}
            removeRange={() => removeRange(index)}
            updateFrom={(from) => updateFrom(index, from)}
            updateTo={(to) => updateTo(index, to)}
            toggleDay={(day) => toggleDay(index, day)}
            onSave={() => onSave()}
          />
        )
      })}
      <button
        className="button is-primary full-width"
        onClick={() => {
          addRange()
        }}
      >
        <i className="fa fa-plus" />
        Add Range
      </button>
    </div>
  )
}

export default Ranges
